'use strict';

(function () {
  'use strict';

  angular.module('msProfile').component('msCustomization', {
    bindings: {
      components: '<',
      user: '<',
      onboarding: '@',
      next: '<',
      inlineUpdatePreferences: '<'
    },
    templateUrl: 'profile/pages/customization.html',
    controller: ['$scope', 'MetadataSvc', 'userSvc', 'customizationOptions', function ($scope, MetadataSvc, userSvc, customizationOptions) {
      var vm = this;
      vm.$onInit = init;
      vm.save = save;
      vm.saveAll = saveAll;
      vm.removeSpiritualPreferences = removeSpiritualPreferences;
      vm.appMode = 'STANDARD';

      var SPIRITUAL_PREFIX = 'spiritual';

      ///////////////////////////////////////

      function init() {
        vm.appMode = vm.user && vm.user.accessCode && vm.user.accessCode.applicationMode ? vm.user.accessCode.applicationMode.name : 'STANDARD';

        vm.preferences = {};
        _.each(vm.components, function (c) {
          _.each(c.tagList, function (t) {
            vm.preferences[t.shortName] = true;
          });
        });

        vm.spiritualOverallImportance = _.some(vm.components, function (c) {
          return c.displayName.toLowerCase() === SPIRITUAL_PREFIX && c.tagList && c.tagList.length > 0;
        });

        vm.componentMappings = customizationOptions[vm.appMode];
      }

      function save(item) {
        var pref = {};
        pref[item] = vm.preferences[item];
        MetadataSvc.updateProfileComponents(pref);
        updateUserProgram(item);
      }

      function saveAll() {
        MetadataSvc.updateProfileComponents(vm.preferences).then(function () {
          for (var pref in vm.preferences) {
            if (vm.preferences.hasOwnProperty(pref)) {
              updateUserProgram(pref);
            }
          }

          vm.next();
        });
      }

      //if updating a condition, we need to maybe update the user's wellnessProgram
      function updateUserProgram(item) {
        if (_.startsWith(item, 'condition')) {
          var conditions = [];
          //find all of the checked conditions
          for (var key in vm.preferences) {
            if (vm.preferences.hasOwnProperty(key) && _.startsWith(key, 'condition') && vm.preferences[key]) {
              conditions.push(key);
            }
          }
          //if only one is checked, make it the program
          //we should update the WA program
          if (conditions.length === 1) {
            var user = {
              wellnessProgram: conditions[0]
            };
            //save the user
            userSvc.saveUser(user);
          }
        }
      }

      function removeSpiritualPreferences() {
        // Find the spiritual component
        var spiritualComponent = vm.components.find(function (component) {
          return component.displayName.toLowerCase() === SPIRITUAL_PREFIX;
        });

        // Set each spiritual list value to false
        var newPrefs = spiritualComponent.listValues.reduce(function (acc, item) {
          acc[item] = false;
          return acc;
        }, {});

        // Update with new preferences
        MetadataSvc.updateProfileComponents(newPrefs);
      }
    }]
  });
})();